import React, { useEffect, useState, useRef } from 'react';
import MediaPlayer from '../utils/MediaPlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5b2_long.mp3");

const Module5b2 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module5b2;

    const [pause, setPause] = useState(true);
    const [back, setBack] = useState(false);
    const [page, setPage] = useState(0);
    const pageRef = useRef(page);

    const [selectedNote, setSelectedNote] = useState([1, 2]);
    const selectedNoteRef = useRef(selectedNote);

    const timesInSeconds = [ // temps de chaque note en secondes
        [null, null, null, null, null, null, null, null],
        [null, null, 51.92, 53.00, 54.29, 55.50, 56.79, 58.08],
        [59.38, 60.71, 61.92, 63.17, 64.58, 65.79, 67.08, 68.42],
        [69.71, 70.92, 72.17, 73.63, 74.79, 76.21, 77.50, 79.00]
    ];

    const offset = 0
    //modify the timesInSeconds array to remove the offset
    for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 8; j++) {
            if (timesInSeconds[i][j] !== null)
                timesInSeconds[i][j] -= offset;
        }
    }


    useEffect(() => {
        var tl = anime.timeline({});
        tl.add({
            targets: '#circle1',
            r: 80,
            duration: 3200,
            easing: 'spring(1, 80, 10, 0)',
        }, '400')
            .add({
                targets: '#circle1',
                r: 450,
                duration: 2800,
                easing: 'easeOutElastic(1, .8)',
            }, '2500')
            .add({
                targets: '#svg',
                zIndex: 1,
                duration: 1,
            }, '3000')
    }, []);

    const notes = [
        ["Gm7", "C7", "Fm7", "Fm7", "Dm7", "G7", "C7M", "C7M"],
        ["Gm7", "C7", "Fm7", "Fm7", "Dm7", "G7", "C7M", "C7M"],
        ["Cm7", "F7", "Bb7M", "Bb7M", "Ab7", "Ab7", "G7", "G7"],
        ["Gm7", "C7", "Fm7", "Fm7", "Dm7", "G7", "C7M", "C7M"]
    ];

    let notesElem = [];
    //Create an array of 8x4 div elements containing the notes repeated 4 times
    for (let j = 0; j < 4; j++) {
        notes[j].forEach((note, index) => {
            notesElem.push(<div className="note"
                key={`${index}:${j}`}
                //id={`${index}:${j}`}
                style={
                    {
                        position: 'absolute',
                        top: j * 54,
                        left: index * 72,
                        width: '70px',
                        height: '35px',
                        border: '2px solid white',
                        backgroundColor: selectedNoteRef.current[1] == index && selectedNoteRef.current[0] == j ? 'blue' : 'transparent',
                        zIndex: 2
                    }
                } >
                <p style={
                    {
                        position: 'relative',
                        top: -10,
                        left: 17,
                        color: 'white',
                        fontSize: '17px'
                    }
                } > {note} </p> </div>
            );
        });
    }


    const reset = () => {
        audio.pause();
        audio.currentTime = 0;
        setPage(0);
        pageRef.current = 0;
        setPause(true);
        setBack(false);
    }

    const goToPage2 = () => {
        setPage(1);
        pageRef.current = 1;
        setPause(false);
        setBack(false);
        audio.play();
        audio.currentTime = timesInSeconds[1][2];
    }

    /* put in blue the correct note, using the timesInSecondArray */
    useEffect(() => {
        setInterval(() => {
            let time = audio.currentTime;
            if (time < timesInSeconds[1][2]) {
                pageRef.current = 0;
                setPage(0);
            } else if (time <= timesInSeconds[3][7] + 1.3) {
                pageRef.current = 1;
                setPage(1);
            }
            // if time is greater than the last time in the array + 1.3 sec, reset audio and go to first page
            else {
                audio.pause();
                audio.currentTime = 0;
                setPage(0);
                pageRef.current = 0;
                setPause(true);
                setBack(false);
            }

            //get the [index, j] corresponding to the current time (t >= timeInSecondArray[index][j])
            let index = 0;
            let j = 0;
            //console.log(time);
            while (j < 4 && (timesInSeconds[j][index] === null || time >= timesInSeconds[j][index])) {
                if (index == 7) {
                    j++;
                    index = 0;
                } else {
                    index++;
                }
            }

            //set the selected note
            setSelectedNote([j, index]);
            selectedNoteRef.current = [j, index];
            //console.log(`selected note: ${j}, ${index}`)
        }, 100);
    }, []);

    return (<>
        <div className="background" > {
            page == 0 &&
            <>
                <MediaPlayer
                    source="module5b2"
                    initialDelay={0}
                    paused={pause}
                    setBack={back}
                />
                <img src={process.env.PUBLIC_URL + "/assets/images/module5b2/intro.png"}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '660px',
                        zIndex: 3,
                        opacity: audio.currentTime <= 0.4 ? 1 : audio.currentTime / 0.5,
                        display: audio.currentTime <= 0.5 ? 'block' : 'none',
                    }}
                    alt="0"
                />
            </>
        }
            {
                page == 1 &&
                <
                    img src={process.env.PUBLIC_URL + "/assets/images/module5b2/1.jpg"}
                    alt="1"
                    style={
                        { position: 'absolute', top: 0, left: 15, opacity: 0.4, zIndex: 1 }}
                />
            }
            {
                page == 1 &&
                <div className="notesContainer"
                    style={
                        {
                            position: 'absolute',
                            top: 200,
                            left: 35
                        }
                    } > {notesElem} </div>
            } <div className="buttonContainer"
                style={
                    { position: 'absolute', top: 450, left: 20, width: '120px', height: '40px', zIndex: 4 }} >
                <img
                    src={process.env.PUBLIC_URL + (pause ? "/assets/images/module5b2/play.png" : "/assets/images/module5b2/play2.png")}
                    alt="play"
                    id="playButton"
                    width="100px"
                    height="100px"
                    onClick={
                        () => {
                            audio.play();
                            setPause(false);
                        }
                    }
                    style={
                        { position: 'relative', width: '20px', height: '20px', margin: 5, zIndex: 2 }}
                />
                <img
                    src={process.env.PUBLIC_URL + (pause ? "/assets/images/module5b2/pause2.png" : "/assets/images/module5b2/pause.png")}
                    alt="pause"
                    id="pauseButton"
                    width="100px"
                    height="100px"
                    onClick={
                        () => {
                            audio.pause();
                            setPause(true);
                        }
                    }
                    style={
                        { position: 'relative', width: '20px', height: '20px', margin: 5, zIndex: 2 }}
                /> <img
                    src={process.env.PUBLIC_URL + (back ? "/assets/images/module5b2/back2.png" : "/assets/images/module5b2/back.png")}
                    alt="back"
                    id='backButton'
                    width="100px"
                    height="100px"
                    onClick={
                        () => {
                            setBack(true);
                            setPause(true);
                            audio.pause();
                            audio.currentTime = 0;
                        }
                    }
                    style={
                        { position: 'relative', width: '20px', height: '20px', margin: 5, zIndex: 2 }}
                />
            </div> { /* page number (1, 2) in blue square clickable to chnage the page */}
            <div className="pageButtonContainer"
                style={
                    { position: 'absolute', top: 450, left: 140, width: '100px', height: '50px', display: "flex", zIndex: 2 }} >
                <div className="pageButton"
                    style={
                        { position: 'relative', width: '20px', height: '20px', margin: 5, zIndex: 4, backgroundColor: page == 0 ? '#4755b5' : '#a9b4fc' }}
                    onClick={
                        () => {
                            reset();
                        }
                    } >
                    <p style={
                        { color: 'white', marginTop: 2, width: 20, height: 20, fontSize: 14, textAlign: 'center', cursor: "pointer" }} > 1 </p>
                </div>
                <div className="pageButton"
                    style={
                        { position: 'relative', width: '20px', height: '20px', margin: 5, zIndex: 2, backgroundColor: page == 1 ? '#4755b5' : '#a9b4fc' }}
                    onClick={
                        () => {
                            goToPage2();
                        }
                    } >
                    <p style={
                        { color: 'white', marginTop: 2, width: 20, height: 20, fontSize: 14, textAlign: 'center', cursor: "pointer" }} > 2 </p>
                </div>
            </div>
            <div className="blackHider"
                style={
                    { position: 'absolute', bottom: 0, left: 0, width: '660px', height: '70px', zIndex: 1, backgroundColor: 'black' }}
            />

            <svg viewBox="0 0 660 500"
                style={
                    { zIndex: 3 }}
                id="svg" >
                <mask id="circles"
                    maskUnits="objectBoundingBox" >
                    <
                        rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="white" />
                    <
                        circle id="circle1"
                        cx="260"
                        cy="150"
                        r="0"
                        fill="black" />
                </mask>
                <
                    rect x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                />
            </svg>

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                style={{
                    position: 'absolute',
                    left: 30,
                    top: 320,
                    color: 'white',
                    width: '600px',
                    fontSize: '16px',
                    zIndex: 2,
                    display: page == 0 ? 'block' : 'none',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                }}
            >{texts.lang30}</p>
        </div>
    </>
    );
}

export default Module5b2;